import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {},
  title: {
    textAlign: 'center',
    marginBottom: ['30px', '70px'],
    marginX: 'auto',
    maxWidth: [null, '948px'],
    color: 'indigo.100',
  },
  mainRowContainer: {
    flexDirection: ['column', 'row'],
    alignItems: ['center', 'flex-start'],
    justifyContent: ['flex-start', 'center'],
  },
  mainRowContainerLeft: {
    flex: 1,
    justifyContent: 'center',
    marginRight: [null, '30px'],
    marginBottom: ['30px', '0px'],
    maxHeight: ['674px'],
    maxWidth: ['698px'],
  },
  image: {
    img: {
      objectFit: 'contain !important',
    },
    width: '100%',
    maxWidth: '100% !important',
  },
  mainRowContainerRight: {
    flex: 1,
    width: '100%',
    marginLeft: [null, '30px'],
  },
  mainRowContainerRightBorder: {
    maxWidth: ['310px', '536px'],
    variant: 'backgrounds.gradient1',
    borderRadius: '12px',
    padding: '3px',
    marginX: ['auto'],
  },
  mainRowContainerRightInner: {
    backgroundColor: 'white',
    borderRadius: '10px',
    height: '100%',
    padding: '48px 48px 60px',
    '> iframe': {
      width: '100%',
    },
  },
  sameSizeColumn: {
    flexBasis: ['100%', '50%'],
    width: ['100%', '50%'],
  },
  formBg: {
    background: 'linear-gradient(76.62deg,#8086F2 -4.79%,#32CDEA 100%)',
    borderRadius: '12px',
    boxShadow: '0px 5px 15px rgb(0 0 0 / 25%)',
    display: 'block',
    margin: '0 auto',
    maxWidth: 'calc(100% - 40px)',
    padding: '3px',
    width: '730px',

    '& > div': {
      backgroundColor: '#fff',
      borderRadius: '10px',
      paddingBottom: ['30px', '60px'],
      paddingTop: ['35px', '70px'],
    },
  },
  main: {
    'input:not([type="submit"]):not([type="button"]):not([type="checkbox"]), select, textarea': {
      background: '#fff',
      border: '2px solid #bfbfbf',
      color: '#7f7f7f',
      display: 'block',
      fontSize: '21px',
      margin: '0 auto',
      marginBottom: '15px',
      padding: '13px 14px 11px',
      width: '100%',

      '&::placeholder': {
        color: '#A0A4A8',
        textTransform: 'uppercase',
      },
    },

    '.single-checkbox-row': {
      position: 'relative',
    },

    'input[type="checkbox"]': {
      display: 'none',
    },

    'input[type="checkbox"] + label': {
      cursor: 'pointer',
      display: 'block',
      marginBottom: '15px',
      transition: 'all 0.3s',

      '&:hover': {
        color: '#35cceb',
      },
    },

    'input[type="checkbox"]:checked + label::after': {
      backgroundColor: '#bfbfbf',
      content: '""',
      display: 'block',
      height: '20px',
      left: '4px',
      position: 'absolute',
      top: '4px',
      width: '20px',
    },

    'input[type="checkbox"] + label::before': {
      background: '#fff',
      border: '2px solid #bfbfbf',
      content: '""',
      float: 'left',
      marginRight: '15px',
      height: '24px',
      width: '24px',
    },

    'form > *': {
      margin: '0 auto',
      maxWidth: 'calc(100% - 40px)',
      position: 'relative',
      width: '434px !important',
    },

    'input[type="submit"], input[type="button"], button': {
      alignItems: 'center',
      backgroundImage: 'linear-gradient(270deg, #35cceb 0, #8781f4)',
      border: 'none',
      borderRadius: '24px',
      boxShadow: '-1px 4px 15.68px 0.32px rgb(0 0 0 / 14%)',
      color: '#fff',
      cursor: 'pointer',
      display: 'block',
      fontSize: '20px',
      fontWeight: 600,
      margin: '0 auto',
      minHeight: '50px',
      minWidth: '233px',
      mt: '50px',
      padding: '10px 20px',
      transition: 'all .3s ease-in',

      '&:hover': {
        backgroundColor: 'var(--theme-ui-colors-sungoldDarken-100,#E2A903)',
        transform: 'scale(1.1)',
      },
    },
  },
};
